// Module
var code = "<a data-bind=\"click: Click, tooltip: {content: SaveBtnText}\" tabindex=\"-1\" class=\"btn green subFormControl saveButton\" id=\"saveBtn\"> <i class=\"fa fa-save\"></i><span><!-- ko text: _labels.SAVE --><!-- /ko --></span> </a>";
// Exports
export default code;